import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { createContext, useContext } from 'react'
import { stepsFleet, stepsLeasing, stepsPoleas, stepsProperty, stepsTravel, stepsVehicle, stepsVehicleExtra } from '../data/steps'

export interface IStep {
  id: number
  title: string
  titleKey: string
  path: string
}

export interface IStepsContext {
  steps?: IStep[]
  currentStepId?: number
  onNavigate?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const StepsContext = createContext<IStepsContext>({})

export const StepsProvider = (
  props: React.PropsWithChildren & { currentStepId?: number; steps?: IStep[] },
) => {
  const { app } = useApp()

  let steps = props.steps
  if (steps) {
    return (
      <StepsContext.Provider value={{ steps, currentStepId: props.currentStepId }}>
        {props.children}
      </StepsContext.Provider>
    )
  }

  switch (app) {
    case Apps.vehicle:
      steps = stepsVehicle
      break
    case Apps.leasing:
      steps = stepsLeasing
      break
    case Apps.fleet:
      steps = stepsFleet
      break
    case Apps.travel:
      steps = stepsTravel
      break
    case Apps.extra:
      steps = stepsVehicleExtra
      break
    case Apps.property:
      steps = stepsProperty
      break
    case Apps.publicPoleas:
      steps = stepsPoleas
      break
  }

  return (
    <StepsContext.Provider
      value={{
        steps: steps,
        currentStepId: props.currentStepId,
      }}
    >
      {props.children}
    </StepsContext.Provider>
  )
}

export const useStepsContext = () => {
  const context = useContext(StepsContext)

  if (!context || context === undefined) {
    throw new Error('useStepsContext must be used within a StepsProvider')
  }

  return context
}
